import { PersonModel, ScheduleModalPeople } from '@/types';

export const person: PersonModel = {
  name: 'Karol',
  surname: 'Sobieraj',
  position: 'Co-Founder & CEO',
  linkedinLink: 'https://www.linkedin.com/in/k-sobieraj/',
  modal: ScheduleModalPeople.karolS
};
